import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import LoadingOverlay from "react-loading-overlay";
import { BILLING_PORTAL, GET_WHO_AM_I } from "./queries";
import { Redirect } from "react-router-dom";
import "./Account.css";
import AccountInfoForm from "./AccountInfoForm";
import ChangePasswordForm from "./ChangePasswordForm";
import Overlay from "../../Overlay";
import LinkButton from "../../LinkButton";

export default function Account() {
  const [showLoading, setShowLoading] = useState(true);
  const [billingPortalUrl, setBillingPortalUrl] = useState(undefined);
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);

  const [getBillingPortal] = useMutation(BILLING_PORTAL);

  function showChangePassword(e) {
    e.preventDefault();

    setShowChangePasswordForm(true);
  }

  function hideChangePassword(e) {
    e.preventDefault();
    setShowChangePasswordForm(false);
  }

  const { loading, error, data } = useQuery(GET_WHO_AM_I, {
    onCompleted: () => {
      setShowLoading(false);

      getBillingPortal()
        .then(({ data }) =>
          setBillingPortalUrl(data.billingPortal.billingPortal.portalUrl)
        )
        .catch(() => setBillingPortalUrl("/memberships"));
    },
  });

  if (loading)
    return (
      <LoadingOverlay
        active={showLoading}
        spinner
        text="Loading account info..."
      >
        <div className="account-container" />
      </LoadingOverlay>
    );
  if (error) return <Redirect to={"/login"} />;

  const whoAmI = data.whoAmI;

  if (!whoAmI) {
    return <Redirect to={"/login"} />;
  }

  let showName = whoAmI.username;
  if (whoAmI.firstName !== null) {
    showName = whoAmI.firstName;
  }

  return (
    <div className="account-container">
      <div className="account-details-container">
        <h1 className="account-header">Account</h1>
        <p>Welcome to Gup&apos;s Corner, {showName}</p>
        <div className="account-links">
          <LinkButton
            classes="account-link account-link-active"
            onClick={(e) => showChangePassword(e)}
          >
            Change Password
          </LinkButton>
          <a href="/avatars" className="account-link account-link-active">
            Avatars
          </a>
          <a
            href={billingPortalUrl !== undefined ? billingPortalUrl : "#"}
            target={billingPortalUrl !== undefined ? "_blank" : "_self"}
            rel="noreferrer"
            className={
              "account-link " +
              (billingPortalUrl !== undefined
                ? "account-link-active"
                : "account-link-inactive")
            }
          >
            Billing Portal
          </a>

          <a href="/logout" className="account-link account-link-active">
            Logout
          </a>
        </div>
        <AccountInfoForm
          firstName={whoAmI.firstName}
          lastName={whoAmI.lastName}
          displayName={whoAmI.displayName}
          slackEmail={whoAmI.slackEmail}
        />

        <Overlay show={showChangePasswordForm}>
          <ChangePasswordForm closeOverlay={hideChangePassword} />
        </Overlay>
      </div>
    </div>
  );
}
